module.exports = __webpack_public_path__ + "media/images/flags/il-4c70e23214e9da6a56eb525f6a31a5c8.svg";